import { render, staticRenderFns } from "./MerchantFeeConfigView.vue?vue&type=template&id=a9eef7f8&"
import script from "./MerchantFeeConfigView.vue?vue&type=script&lang=js&"
export * from "./MerchantFeeConfigView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports